import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string().default('/api'),
  VITE_VAPID_PUBLIC_KEY: z.string().optional().default(''),
  VITE_APP_TITLE: z.string().default('ManageMate Client'),
});

const _env = envSchema.safeParse(import.meta.env);

if (!_env.success) {
  console.error('❌ Invalid client environment variables:', _env.error.format());
  throw new Error('Invalid client environment variables');
}

export const env = _env.data;
